import * as Yup from 'yup';

/**
 * Login validation schema
 */
export const loginSchema = Yup.object({
  email: Yup.string()
    .email('Please provide a valid email address')
    .max(255, 'Email must not exceed 255 characters')
    .required('Email is required')
    .trim()
    .lowercase(),
  password: Yup.string()
    .required('Password is required')
    .max(128, 'Password must not exceed 128 characters'),
});

/**
 * Change password validation schema
 */
export const changePasswordSchema = Yup.object({
  currentPassword: Yup.string()
    .required('Current password is required'),
  newPassword: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters long')
    .max(128, 'Password must not exceed 128 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)'
    )
    .test('different-from-current', 'New password must be different from current password', function(value) {
      return value !== this.parent.currentPassword;
    }),
  confirmPassword: Yup.string()
    .required('Please confirm your new password')
    .oneOf([Yup.ref('newPassword')], 'Passwords do not match'),
});

/**
 * Email validation schema (for forgot password)
 */
export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .email('Please provide a valid email address')
    .max(255, 'Email must not exceed 255 characters')
    .required('Email is required')
    .trim()
    .lowercase(),
});
